export default __webpack_public_path__ + "static/media/virtual-experience.169523ad.webp";